/* 
    For each .product-card__custom-badge--new element
    check if creation date exceeds 180 days = roughly 
    half a year.
    If it does remove the badge element from the DOM.
*/
document.addEventListener('DOMContentLoaded', function () {
    const badges = document.querySelectorAll('.product-card__custom-badge--new');

    badges.forEach(function (badge) {
        const creationDate = new Date(badge.dataset.creationDate);
        const currentDate = new Date();
        const daysDifference = Math.floor((currentDate - creationDate) / (1000 * 60 * 60 * 24));

        if (daysDifference > 180) {
            badge.remove();
        }
    });
});